import React from "react";

const ReplyInput = ({
  user,
  setComment,
  setReply,
  comment,
  handleSubmit,
  el,
  reply,
}) => {
  return (
    <>
      <div className="flex justify-between items-center mt-2">
        <p className="inline-flex items-center w-full">
          <img
            alt="user"
            src={user?.user?.avatar}
            className="w-8 h-8 rounded-full flex-shrink-0 object-cover object-center"
          />
          <input
            className="border-b border-black ml-2 w-full py-2 outline-none dark:bg-[#1d1e2b] dark:text-white px-2"
            type="text"
            name="reply"
            id="reply"
            placeholder="Add a reply"
            onChange={(e) => setComment(e.target.value)}
          />
        </p>
      </div>
      <div className="text-right w-full">
        <button
          className="mx-2 dark:text-white"
          onClick={() => setReply(!reply)}
        >
          Cancel
        </button>
        <button
          disabled={comment.length > 0 ? false : true}
          className={`${
            comment.length > 0 ? "opacity-100" : "opacity-50 cursor-not-allowed"
          } mx-2 my-2 text-white text-sm bg-[#1D4ED8] border-0 px-2 py-2 focus:outline-none hover:bg-indigo-600`}
          onClick={() => handleSubmit(el)}
        >
          Reply
        </button>
      </div>
    </>
  );
};

export default ReplyInput;
